import _Cmp from '../_app/cuchillo/windows/Cmp';

export default class CMP extends _Cmp {
    static show__effect(__d = 0) {
        this.container.style.opacity = "1";
    }

    static hide__effect(__d = 0) {
        this.container.style.display = "none";
        super.dispose();
    }
}


